<script>
    import { createEventDispatcher } from "svelte";
    import { swipe } from "../../utils/dragMove";
    export let date = false;
    export let unit = ""; //单位
    export let items = [];
    export let value = ""; //选中值的索引
    export let name = "picker"; //唯一标识组件的名称
    export let index = -1
    const dispatch = createEventDispatcher();
    //定义变量
    let el;
    let selectedIndex = 1;
    let len = items.length;
    //接收滚动后的回调
    function handleEnd(event) {
        selectedIndex = event.detail.index;
        console.log(selectedIndex,99999);
        fireEvent();
    }
    //监控数据变化
    $: {
        items = formartItems(items);
        len = items.length;
        selectedIndex = getIndex(value);
    }
    //
    function formartItems(data) {
        const arr = JSON.parse(JSON.stringify(data));
        arr.unshift("");
        arr.push("");
        return arr;
    }
    //触发事件
    function fireEvent() {
        dispatch("change", { val: items[selectedIndex], name,index });
    }
    //获取选中的索引值
    function getIndex(value) {
        let hook = 1;
        if (value === "") {
            return hook;
        }
        if (items && items.length > 2) {
            items.map((el, index) => {
                if (el === value || el.name === value) {
                    hook = index;
                }
            });
        }
        return hook;
    }
    //
    function calcNum(n) {
        if (date && n > 0 && n < 10) {
            return "0";
        } else {
            return "";
        }
    }
    //
    function getName(item) {
        if (item === "") return item;
        return item.name ? item.name : item;
    }

    const clsPrefix = "sui-picker";
</script>

{#if items && items.length > 0}
    <div class={`${clsPrefix} ${$$props.class}`} bind:this={el} class:date>
        <div
            class={`${clsPrefix}-inner`}
            use:swipe={{ len, activeIndex: selectedIndex }}
            on:dragend={handleEnd}
        >
            {#each items as item, index}
                <div
                    class:active={index === selectedIndex}
                    class={`${clsPrefix}-item`}
                >
                    <span title={getName(item)}>{calcNum(getName(item))}{getName(item)}</span>
                    {#if unit && item !== ""}<small>{unit}</small>{/if}
                </div>
            {/each}
        </div>
    </div>
{/if}

<style lang="less">
    @import "./picker.less";
</style>
